var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.75201H4.647C5.732 8.75201 6.611 7.87301 6.611 6.78801V6.78801C6.611 6.26701 6.404 5.76701 6.036 5.39901L4.332 3.69501",
    stroke: "#0074B2",
    strokeWidth: 1.4423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3689 13.223L11.1349 11.372C10.9119 11.037 10.5359 10.836 10.1329 10.836V10.836C9.67693 10.836 9.25993 10.578 9.05593 10.17L8.96393 9.98501C8.79393 9.64601 8.79393 9.24701 8.96393 8.90801L9.75093 7.33501C9.95493 6.92701 10.3719 6.66901 10.8279 6.66901H13.8889",
    stroke: "#0074B2",
    strokeWidth: 1.4423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.75H5",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.75L1.636 15.114C5.15 18.628 10.85 18.629 14.364 15.114C17.878 11.6 17.878 5.9 14.364 2.386C14.023 2.045 13.656 1.747 13.278 1.472L14 0.75",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.75V20.75",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4194 4.33258C14.8602 6.77336 14.8602 10.7306 12.4194 13.1714C9.97864 15.6122 6.02135 15.6122 3.58059 13.1714C1.13981 10.7306 1.13981 6.77335 3.58059 4.33258C6.02136 1.8918 9.97865 1.8918 12.4194 4.33258",
    stroke: "#0074B2",
    strokeWidth: 1.4423,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.0cfe571cfb46b3228056cb15493dd934.svg";
export { ForwardRef as ReactComponent };